import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import { Suspense, lazy } from 'react';

import { AudiencePage } from '@/pages/AudiencePage';
import { AudienceProvider } from '@/context/audience-context';
import { CallbackPage } from './pages/CallbackPage';
import { GlobalSnackbar } from './components/molecules';
import { HomePage } from './pages/Homepage';
import { IAudience } from '@/interfaces';
import { InsightPage } from '@/pages/InsightPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ProtectedRoute } from '@/components/routes';
import { SnackbarProvider } from '@/context/snackbar-context';
import { UnauthorizedPage } from './pages/unauthorized-page';

const LazyActivationPage = lazy(
  () => import('./pages/activation/ActivationPage')
);
const LazyActivationsPage = lazy(
  () => import('./pages/activation/ActivationsPage')
);

const defaultState: IAudience[] = [];

function App() {
  return (
    <SnackbarProvider>
      <AudienceProvider initialState={defaultState}>
        <Router>
          <Switch>
            <ProtectedRoute path="/" exact component={HomePage} />
            <ProtectedRoute
              exact
              path="/audience/new"
              component={AudiencePage}
            />
            <ProtectedRoute
              exact
              path="/audience/:id"
              component={AudiencePage}
            />
            <ProtectedRoute
              exact
              path="/audience/:id/insight"
              component={InsightPage}
            />
            <ProtectedRoute
              exact
              path="/audience/:audience_id/activation"
              component={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyActivationsPage />
                </Suspense>
              )}
            />
            <ProtectedRoute
              exact
              path="/audience/:audience_id/activation/new"
              component={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyActivationPage />
                </Suspense>
              )}
            />
            <ProtectedRoute
              exact
              path="/audience/:audience_id/activation/:activation_id"
              component={() => (
                <Suspense fallback={<div>Loading...</div>}>
                  <LazyActivationPage />
                </Suspense>
              )}
            />
            <Route path="/callback" component={CallbackPage} />
            <Route path="*" component={NotFoundPage} />
            {/* If the user is rejected by log-in, redirect them to the unauthorized page */}
            <Route path="/unauthorized" component={UnauthorizedPage} />

            {/* Redirect /login to AppWrapper to delegate auth decisions */}
            <Redirect from="/login" to="/" />
          </Switch>
        </Router>
        <GlobalSnackbar />
      </AudienceProvider>
    </SnackbarProvider>
  );
}

export default App;
